import { render, staticRenderFns } from "./errorRegister.vue?vue&type=template&id=748d7e4b&scoped=true&"
import script from "./errorRegister.vue?vue&type=script&lang=js&"
export * from "./errorRegister.vue?vue&type=script&lang=js&"
import style0 from "./errorRegister.vue?vue&type=style&index=0&id=748d7e4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d7e4b",
  null
  
)

export default component.exports